import {administrationRoutes, administrationRoutingAddress} from "../administration/routing/administrationRouting";
import {alertsRoutingAddress, alertsRoutes} from "../alerts/routing/alertsRouting";
import {dictionariesRoutes, dictionariesRoutingAddress} from "../dictionaries/routing/dictionariesRouting";
import {documentsRoutingAddress, documentsRoutes} from "../documents/routing/documentsRouting";
import {placeRoutes, placeRoutingAddress} from "../place/routing/placeRouting";
import {timetableRoutes, timetableRoutingAddress} from "../timetables/routing/timetablesRouting";
import {topologyRoutingAddress, topologyRoutes} from "../topology/routing/topologyRouting";
import {orderRoutingAddress, orderRoutes, ticketRoutingAddress, ticketRoutes} from "../transportation/routing/transportationRouting";
import {userRoutes, userRoutingAddress} from "../common/routing/userRouting";
import {reportsRoutes, reportsRoutingAddress} from "../reports/routing/reportsRouting";
import {priceListRoutes, priceListRoutingAddress} from "../priceList/routing/priceListRouting";

export const routingAddresses = {
    dictionaries: dictionariesRoutingAddress,
    timetable: timetableRoutingAddress,
    administration: administrationRoutingAddress,
    user: userRoutingAddress,
    ticket: ticketRoutingAddress,
    topology: topologyRoutingAddress,
    documents: documentsRoutingAddress,
    order: orderRoutingAddress,
    alerts: alertsRoutingAddress,
    place: placeRoutingAddress,
    reports: reportsRoutingAddress,
    priceList: priceListRoutingAddress
};

export const routes = [
    ...dictionariesRoutes,
    ...timetableRoutes,
    ...administrationRoutes,
    ...userRoutes,
    ...ticketRoutes,
    ...topologyRoutes,
    ...documentsRoutes,
    ...orderRoutes,
    ...alertsRoutes,
    ...placeRoutes,
    ...reportsRoutes,
    ...priceListRoutes
];
